import { render, staticRenderFns } from "./add-app.vue?vue&type=template&id=cd66afc6&scoped=true&"
import script from "./add-app.vue?vue&type=script&lang=ts&"
export * from "./add-app.vue?vue&type=script&lang=ts&"
import style0 from "./add-app.vue?vue&type=style&index=0&id=cd66afc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd66afc6",
  null
  
)

export default component.exports